var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow2Squarepath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 29.3794 21.5977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 21.5977,
    opacity: 0,
    width: 29.3794,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6292 17.5547C22.6292 18.0703 23.0628 18.4922 23.5784 18.4922C24.094 18.4922 24.5159 18.0703 24.5159 17.5547L24.5159 3.65625C24.5159 1.23047 23.2854 0.0234375 20.8479 0.0234375L11.3089 0.0234375C10.6409 0.0234375 10.2424 0.363281 10.2542 0.960938C10.2659 1.55859 10.6409 1.91016 11.3089 1.91016L20.8128 1.91016C21.9846 1.91016 22.6292 2.53125 22.6292 3.75ZM26.2503 14.6016L23.5784 17.5078L20.8831 14.6016L19.7581 13.5C19.3596 13.1133 18.8089 13.0664 18.3987 13.4648C18.012 13.8633 18.0237 14.4375 18.4339 14.8359L22.3714 18.7617C23.1448 19.5234 24.0003 19.5234 24.762 18.7617L28.7112 14.8359C29.1096 14.4375 29.1331 13.8633 28.7346 13.4648C28.3362 13.0664 27.7854 13.1016 27.3753 13.5ZM6.3987 4.06641C6.3987 3.55078 5.9651 3.12891 5.44948 3.12891C4.93385 3.12891 4.51198 3.55078 4.51198 4.06641L4.51198 17.9648C4.51198 20.3906 5.74245 21.5977 8.17995 21.5977L17.719 21.5977C18.387 21.5977 18.7854 21.2578 18.7737 20.6602C18.762 20.0508 18.387 19.7109 17.719 19.7109L8.2151 19.7109C7.04323 19.7109 6.3987 19.0898 6.3987 17.8711ZM2.76588 7.00781L5.44948 4.11328L8.13307 7.00781L9.25807 8.12109C9.65651 8.50781 10.219 8.55469 10.6174 8.14453C11.0159 7.75781 10.9924 7.18359 10.594 6.78516L6.64479 2.84766C5.88307 2.09766 5.0276 2.09766 4.26588 2.84766L0.316665 6.78516C-0.0934915 7.18359-0.10521 7.75781 0.281509 8.14453C0.691665 8.55469 1.24245 8.50781 1.64088 8.12109Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2Squarepath);
export default __webpack_public_path__ + "static/media/arrow.2.squarepath.8f172103bc92d281c16ecb30f1a97618.svg";
export { ForwardRef as ReactComponent };